<template>
    <div id="app">
       <Layout />
    </div>
</template>

<script>
const Layout = () => import('./layout/index.vue')

export default {
    components: { Layout},
    data() {
        return {}
    },
    beforeMount() {},
    mounted() {},
    methods: {}
}
</script>

<style lang="less">
html,
body {
    overflow: hidden;
}
</style>
